(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/tickets-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/tickets-slice.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _RTK = RTK,
  createSlice = _RTK.createSlice;
const gamePackageSlice = svs.gamePackage.redux.gamePackageSlice;
const packageConfig = svs.gamePackage.data.packageConfig;
const packageSizes = packageConfig.packageSizes,
  _packageConfig$defaul = packageConfig.defaultSelectedIndex,
  defaultSelectedIndex = _packageConfig$defaul === void 0 ? 1 : _packageConfig$defaul;
const packageGame = svs.ticketgames.gameHandler.getPackageGame();
const generateTicketArray = function () {
  var _packageSizes$activeI, _packageSizes$activeI2;
  let activeIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSelectedIndex;
  return (_packageSizes$activeI = (_packageSizes$activeI2 = packageSizes[activeIndex]) === null || _packageSizes$activeI2 === void 0 || (_packageSizes$activeI2 = _packageSizes$activeI2.tickets) === null || _packageSizes$activeI2 === void 0 ? void 0 : _packageSizes$activeI2.map(ticket => _objectSpread(_objectSpread({}, ticket), packageGame)).map(game => {
    const packageGameConfig = game.packageGameConfig;
    return _objectSpread(_objectSpread({}, game), {}, {
      skin: packageGameConfig === null || packageGameConfig === void 0 ? void 0 : packageGameConfig.skin
    });
  })) !== null && _packageSizes$activeI !== void 0 ? _packageSizes$activeI : [];
};
const ticketsSlice = createSlice({
  name: 'tickets',
  initialState() {
    var _generateTicketArray;
    return {
      games: (_generateTicketArray = generateTicketArray(defaultSelectedIndex)) !== null && _generateTicketArray !== void 0 ? _generateTicketArray : [],
      id: packageSizes[defaultSelectedIndex].gamePackageId
    };
  },
  extraReducers: builder => {
    builder.addCase(gamePackageSlice.actions.updateIndex, (state, action) => {
      const activeIndex = parseInt(action.payload.activeIndex, 10);
      state.games = generateTicketArray(activeIndex);
      state.id = packageSizes[defaultSelectedIndex].gamePackageId;
    });
  }
});
svs.gamePackage.redux.ticketsSlice = ticketsSlice;

 })(window);